// For server side rendering, we make origin from the request headers.
export async function getOriginFromReq() {
  const { headers: nextHeaders } = await import('next/headers');
  const header = await nextHeaders();

  const host = header.get('host') ?? '';
  const protocol = header.get('x-forwarded-proto') ?? 'http';
  return `${protocol}://${host}`;
}
